import { initAnalogClock } from './analog-clock.js';

export function initClockbar({ canvas, timeEl, dateEl, hebrewDateEl, timeZone }) {
    const clockInstance = canvas ? initAnalogClock(canvas) : null;
    let intervalId = null;

    if (timeEl && dateEl && hebrewDateEl) {
        const refresh = function () {
            const now = new Date();
            timeEl.textContent = now.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
                timeZone
            });
            dateEl.textContent = now.toLocaleDateString('en-US', {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                timeZone
            });
            hebrewDateEl.textContent = new Intl.DateTimeFormat('en-u-ca-hebrew', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                timeZone
            }).formatToParts(now)
                .filter((part) => part.type !== 'era')
                .map((part) => part.value)
                .join('')
                .trim();
        };

        refresh();
        intervalId = setInterval(refresh, 1000);
    }

    return {
        destroy() {
            if (clockInstance) {
                clockInstance.destroy();
            }
            if (intervalId) {
                clearInterval(intervalId);
            }
        }
    };
}
